export default "__VITE_ASSET__C$ms5Kab__"